import React from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useSelectedProductValues } from "../../hooks";
import { useWatch } from "react-hook-form";
import { useProduct } from "../../adapters/uplist";

const Subtotal = () => {
  const { pathname } = useLocation();
  const { data: stock_product } = useProduct("1309");
  const paid_stock_count = useWatch({ name: "1309" });
  const stock_subtotal = paid_stock_count * stock_product.price;
  const { prices } = useSelectedProductValues();
  const subtotal = Object.values(prices).reduce((a, b) => a + b, 0);
  return (
    <div className="subtotal-box text-right">
      <Row>
        {pathname === "/stock-photos" && (
          <Col>
            <div className="title">Stock Photo Subtotal</div>
            <div className="subtotal">${stock_subtotal.toFixed(2)} + tax</div>
          </Col>
        )}
        <Col>
          <div className="title">Est. Subtotal</div>
          <div className="subtotal">${subtotal.toFixed(2)} + tax</div>
        </Col>
      </Row>
    </div>
  );
};

export default Subtotal;
